import React, { useState, useEffect } from 'react';
import { Card, Form, Row, Col, Button } from 'react-bootstrap';
import { getFromAPI, postToAPI, formatISODateWithTimezone } from "../../../Utils/utils";
import { toast } from 'react-toastify';
import { useBranch, BranchProvider } from './getBranchData'; // Import the useCustomer hook
import messages from "../../../Utils/lang";
import FormInputs from '../../../Utils/FormInputs';

export default function NewBranch({ onSuccess }) {

  const date = new Date();
  const futureDate = date.getDate();
  date.setDate(futureDate);
  const defaultValue = date.toLocaleDateString('en-CA');
  const initialInputData = {
    name: '',
    business_name: '',
    location: '',
    country: 0,
    state: 0,
    city: 0,
    phone_number_1: '',
    pan_card_number: '',
    gst_number: '',
    tax_id: 0,
    tax_type: 1,
    branch_type_id: 0,
    bank_name: 0,
    bank_account_no: '0',
    bank_ifsc_code: '0',
    owner_user_id: 1,
    created_user_id: 1,
    last_modified_user_id: 1,
    created_date_time: formatISODateWithTimezone(new Date()),
    last_modified_date_time: formatISODateWithTimezone(new Date()),
    isonline: 0,
    isactive: 1,
    isdeleted: 0,
    reserve_varchar1: 'NA',
    reserve_varchar2: 'NA',
    reserve_float1: 0.0,
    reserve_float2: 0.0,
    reserve_int1: 0,
    reserve_int2: 0,
    reserve_double1: 0.0,
    reserve_date1: new Date().toISOString().split('T')[0]
  };

  // const { fetchBranchData } = useBranch();
  const { fetchBranchData, getBranchData } = useBranch();
  const [branchInputData, setBranchInputData] = useState({ ...initialInputData });
  const [countryData, setCountryData] = useState([]);
  const [stateData, setStateData] = useState([]);
  const [cityData, setCityData] = useState([]);
  const [bankData, setbankData] = useState([]);
  const [taxData, setTaxData] = useState([]);

  // Fetch country data
  useEffect(() => {
    const fetchCountryData = async () => {
      try {
        const response = await getFromAPI('FtsCountries/');
        setCountryData(response);
      } catch (error) {
        console.error('Error fetching country data:', error);
      }
    };
    fetchCountryData();
  }, []);

  const fetchBankData = async () => {
    try {
      const response = await getFromAPI('FtsBanks/');
      setbankData(response); // Save tax data
    } catch (error) {
      console.error('Error fetching tax data:', error);
    }
  };
  useEffect(() => {
    fetchBankData();
  }, []);

  useEffect(() => {
    const fetchTaxData = async () => {
      try {
        const response = await getFromAPI('FtsTaxes/');
        setTaxData(response); // Save tax data
      } catch (error) {
        console.error('Error fetching tax data:', error);
      }
    };

    fetchTaxData();
  }, []);

  const handleNewBranchInputChange = (index, field, value) => {
    if (field === "gst_number") {
      handleGSTChange(value); // Pass the value directly, not the event
    }
    setBranchInputData({ ...branchInputData, [field]: value });
  };

  // Fetch bank data
  useEffect(() => {
    const fetchBankData = async () => {
      try {
        const response = await getFromAPI('FtsBanks/');
        setbankData(response);
      } catch (error) {
        console.error('Error fetching bank data:', error);
      }
    };
    fetchBankData();
  }, []);

  // Fetch tax data
  useEffect(() => {
    const fetchTaxData = async () => {
      try {
        const response = await getFromAPI('FtsTaxes/');
        setTaxData(response);
      } catch (error) {
        console.error('Error fetching tax data:', error);
      }
    };
    fetchTaxData();
  }, []);

  // Handle country change and fetch states
  const handleCountryChange = async (e) => {
    const selectedCountry = e.target.value;
    setBranchInputData((prevState) => ({ ...prevState, country: parseInt(selectedCountry) }));
    try {
      const response = await getFromAPI(`FtsState/?country_code=${selectedCountry}`);
      setStateData(response);
      setCityData([]); // Reset city data
    } catch (error) {
      console.error('Error fetching state data:', error);
    }
  };

  // Handle state change and fetch cities
  const handleStateChange = async (e) => {
    const selectedState = e.target.value;
    setBranchInputData((prevState) => ({ ...prevState, state: parseInt(selectedState) }));
    try {
      const response = await getFromAPI(`FtsCity/?state_id=${selectedState}`);
      setCityData(response);
    } catch (error) {
      console.error('Error fetching city data:', error);
    }
  };

  // Function to extract state code and PAN from GST number
  const handleGSTChange = async (gstNumber) => {
    setBranchInputData(prevState => ({ ...prevState, gst_number: gstNumber }));

    if (gstNumber.length >= 15) { // Standard GST number length is 15
      const stateCode = gstNumber.substring(0, 2);
      const panNumber = gstNumber.substring(2, 12);

      // Update PAN automatically
      setBranchInputData(prevState => ({
        ...prevState,
        pan_card_number: panNumber
      }));

      try {
        // First get the country code for India (assuming GST is Indian)
        const countryResponse = await getFromAPI('FtsCountries/?calling_code=91');
        if (countryResponse.length > 0) {
          const countryCode = countryResponse[0].calling_code;

          // Set country to India
          setBranchInputData(prevState => ({
            ...prevState,
            country: countryCode
          }));

          // Fetch state data using the state code from GST
          const stateResponse = await getFromAPI(`FtsState/?state_id=${stateCode}`);
          setStateData(stateResponse)
          if (stateResponse.length > 0) {
            const stateData = stateResponse[0];

            // Update state
            setBranchInputData(prevState => ({
              ...prevState,
              state: stateData.state_id,
              pan_card_number: panNumber,
            }));

            // Fetch and set cities for the selected state
            const cityResponse = await getFromAPI(`FtsCity/?state_id=${stateData.state_code}`);
            setCityData(cityResponse);
            // Set the first city as default if cities are available
            if (cityResponse && cityResponse.length > 0) {
              setBranchInputData(prevState => ({
                ...prevState,
                city: cityResponse[0].id
              }));
            }
          }
        }
      } catch (error) {
        toast.error('Error processing GST number');
      }
    }
  };

  // Handle form submission
  const handleNewBranchSubmit = async () => {
    // Validate required fields
    if (!branchInputData.name.trim()) {
      toast.error(messages.branch.required_name);
      return;
    }
    if (!branchInputData.business_name.trim()) {
      toast.error(messages.branch.required_business_name);
      return;
    }
    if (!branchInputData.location.trim()) {
      toast.error(messages.branch.required_location);
      return;
    }
    if (!branchInputData.phone_number_1 || branchInputData.phone_number_1.length !== 10) {
      toast.error(messages.branch.required_mobile);
      return;
    }
    if (!branchInputData.country) {
      toast.error(messages.branch.required_country);
      return;
    }
    if (!branchInputData.state) {
      toast.error(messages.branch.required_state);
      return;
    }
    if (!branchInputData.city) {
      toast.error(messages.branch.required_city);
      return;
    }
    if (!branchInputData.gst_number) {
      toast.error('GST Number is required');
      return;
    }
    if (!branchInputData.pan_card_number) {
      toast.error('PAN Number is required');
      return;
    }
    if (!branchInputData.bank_name) {
      toast.error('Bank Name is required');
      return;
    }
    if (!branchInputData.bank_account_no) {
      toast.error('Bank Account Number is required');
      return;
    }
    if (!branchInputData.bank_ifsc_code) {
      toast.error('Bank IFSC Code is required');
      return;
    }
  
    // Check if getBranchData is available and is an array before proceeding
    if (Array.isArray(getBranchData)) {
      // Check for existing phone number
      const isExists = getBranchData.find(branch => 
        branch.phone_number_1 === branchInputData.phone_number_1
      );
      if (isExists) {
        toast.error(messages.branch.already_exist);
        return;
      }
  
      // Check for existing branch name
      const isBranchNameExists = getBranchData.find(branch =>
        branch.name === branchInputData.name.trim()
      );
      if (isBranchNameExists) {
        toast.error(messages.branch.already_exist_name);
        return;
      }
    } else {
      // Optional: Handle the case where getBranchData isn't ready
      console.warn('Branch data not available yet');
      // You might want to return here or proceed depending on requirements
    }
  
    try {
      const response = await postToAPI('FtsBranch/', branchInputData);
      if (response.status) {
        toast.success(messages.branch.branch_add);
        fetchBranchData(); // Refresh branch data
        if (onSuccess && response.data.id) {
          onSuccess(response.data.id);
        }
        setBranchInputData(initialInputData); // Reset form
      } else {
        toast.error(messages.branch.failed_to_add);
      }
    } catch (error) {
      console.error('Error submitting branch:', error);
      toast.error('An error occurred while adding the Branch');
    }
  };

  const handleCancel = () => {
    setBranchInputData(initialInputData);
  };

  const isFormValid = () => {
    return (
      branchInputData.name.trim() &&
      branchInputData.business_name.trim() &&
      branchInputData.location.trim() &&
      branchInputData.phone_number_1 &&
      branchInputData.country &&
      branchInputData.state &&
      branchInputData.city && branchInputData.gst_number
      && branchInputData.pan_card_number
      && branchInputData.bank_account_no && branchInputData.bank_ifsc_code && branchInputData.bank_name

    );
  };

  const newBranchRows = [
    {
      columns: [
        { 
          size: { xl: 6 }, 
          label: <>Branch Name <span style={{ color: 'red' }}>*</span></>, 
          type: 'text', 
          placeholder: 'Enter branch name...', 
          name: 'name', 
          id: 'branchName', 
          value: branchInputData.name, 
          errormsg: '', 
        },
        { 
          size: { xl: 6 }, 
          label: <>Business Name <span style={{ color: 'red' }}>*</span></>, 
          type: 'text', 
          placeholder: 'Enter business name...', 
          name: 'business_name', 
          id: 'businessName', 
          value: branchInputData.business_name, 
          errormsg: '', 
        },
        { 
          size: { xl: 4 }, 
          label: <>Phone Number <span style={{ color: 'red' }}>*</span></>, 
          type: 'number', 
          placeholder: 'Enter phone number...', 
          name: 'phone_number_1', 
          id: 'phone_number_1', 
          value: branchInputData.phone_number_1, 
          errormsg: '', 
        },
        { 
          size: { xl: 8 }, 
          label: <>Location <span style={{ color: 'red' }}>*</span></>, 
          type: 'text', 
          placeholder: 'Enter location...', 
          name: 'location', 
          id: 'location', 
          value: branchInputData.location, 
          errormsg: '', 
        },
        { 
          size: { sm: 6, xl: 4 }, 
          label: <>GST No <span style={{ color: 'red' }}>*</span></>, 
          type: 'text', 
          placeholder: 'Enter gst no...', 
          name: 'gst_number', 
          id: 'gstNo', 
          value: branchInputData.gst_number, 
          errormsg: '', 
        },
        {
          size: { sm: 6, xl: 4 }, 
          label: <>Country <span style={{ color: 'red' }}>*</span></>, 
          type: 'select', 
          name: 'country', 
          id: 'country', 
          value: branchInputData.country, 
          errormsg: '',
          options: [
            { value: '', label: 'Select Country' },
            ...countryData.map(item => ({ value: item.calling_code, label: item.short_name }))
          ],
        },
        {
          size: { sm: 6, xl: 4 }, 
          label: <>State <span style={{ color: 'red' }}>*</span></>, 
          type: 'select', 
          name: 'state', 
          id: 'state', 
          value: branchInputData.state, 
          errormsg: '',
          options: [
            { value: '', label: 'Select State' },
            ...stateData.map(item => ({ value: item.state_id, label: item.state_name }))
          ],
        },
        {
          size: { sm: 6, xl: 4 }, 
          label: <>City <span style={{ color: 'red' }}>*</span></>, 
          type: 'select', 
          name: 'city', 
          id: 'city', 
          value: branchInputData.city, 
          errormsg: '',
          options: [
            { value: '', label: 'Select State' },
            ...cityData.map(item => ({ value: item.id, label: item.city_name }))
          ],
        },
        { 
          size: { sm: 6, xl: 4 }, 
          label: <>PAN No <span style={{ color: 'red' }}>*</span></>, 
          type: 'text', 
          placeholder: 'Enter pan no...', 
          name: 'pan_card_number', 
          id: 'panNo', 
          value: branchInputData.pan_card_number, 
          errormsg: '', 
        },
        {
          size: { sm: 6, xl: 4 }, 
          label: <>Tax <span style={{ color: 'red' }}>*</span></>, 
          type: 'select', 
          name: 'tax_id', 
          id: 'tax', 
          value: branchInputData.tax_id, 
          errormsg: '',
          options: [
            { value: '', label: 'Select Tax' },
            ...taxData.map(item => ({ value: item.id, label: item.name }))
          ],
        },
        {
          size: { sm: 6, xl: 4 }, 
          label: <>Tax Type <span style={{ color: 'red' }}>*</span></>, 
          type: 'select', 
          name: 'tax_type', 
          id: 'taxType', 
          value: branchInputData.tax_type, 
          errormsg: '',
          options: [{ value: '1', label: 'Inclusive' }, { value: '2', label: 'Exclusive' }]
        },
        {
          size: { sm: 6, xl: 4 }, 
          label: <>Branch Type <span style={{ color: 'red' }}>*</span></>, 
          type: 'select', 
          name: 'branchType', 
          id: 'branchType', 
          value: branchInputData.branchType, 
          errormsg: '',
          options: [{ value: '1', label: 'Self' }, { value: '2', label: 'Franchies' }],
        },
        {
          size: { sm: 6, xl: 4 }, 
          label: <>Bank Name <span style={{ color: 'red' }}>*</span></>, 
          type: 'select', 
          name: 'bank_name', 
          id: 'bankName', 
          value: branchInputData.bank_name, 
          errormsg: '',
          options: [
            { value: '', label: 'Select Bank Name' },
            ...bankData.map(item => ({ value: item.bank_id, label: item.bank_name }))
          ],
        },
        { 
          size: { md: 6 }, 
          label: <>Bank Account No <span style={{ color: 'red' }}>*</span></>, 
          type: 'text', 
          placeholder: 'Enter bank account no...', 
          name: 'bank_account_no', 
          id: 'bankAccountNo', 
          value: branchInputData.bank_account_no, 
          errormsg: '', 
        },
        { 
          size: { md: 6 }, 
          label: <>Bank IFSC Code <span style={{ color: 'red' }}>*</span></>, 
          type: 'text', 
          placeholder: 'Enter bank IFSC code...', 
          name: 'bank_ifsc_code', 
          id: 'bankIFSCCode', 
          value: branchInputData.bank_ifsc_code, 
          errormsg: '', 
        },
      ]
    },
  ];

  const newBranchButtons = [
    { variant: "primary", text: "Add", onClick: handleNewBranchSubmit, disabled: !isFormValid() },
    { variant: "secondary", text: "Cancel", onClick: handleCancel },
  ];
  return (
    <>
      <Card className='right-content-details'>
        <Card.Body>
          <Card.Title>New Branch</Card.Title>
          <FormInputs Buttons={newBranchButtons} rows={newBranchRows} handleInputChange={handleNewBranchInputChange} handleSubmit={handleNewBranchSubmit} />
        </Card.Body>
      </Card>
    </>
  )
}
